import { toast } from 'sonner';

/** The `mutate` of useDeleteBoatMedia, narrowed to what this helper calls. */
export type DeleteBoatImage = (
  variables: { boatId: string; mediaId: number },
  options?: { onSuccess?: () => void; onError?: () => void },
) => void;

/**
 * #1219 — the one "delete an image, then toast" block the canvas card and the
 * detail-page gallery share (it had been copied three times).
 */
export function deleteImageWithToast(deleteMedia: DeleteBoatImage, boatId: string, mediaId: number): void {
  deleteMedia(
    { boatId, mediaId },
    {
      onSuccess: () => toast.success('Image deleted.'),
      onError: () => toast.error('Failed to delete image.'),
    },
  );
}
